import * as React from 'react';
import Menu, { MenuItem } from 'material-ui/Menu';
import Button from 'material-ui/Button';

interface OwnProps {
  label?: string;
  filter?: boolean;
  onSelected: (itemValue: string | null) => void;
}

interface StateProps {
  isOpen: boolean;
  anchorEl?: any;
}

export const TYPE_NO_TARGET = null;
export const TYPE_BRAND = 'brand';
export const TYPE_PRODUCT = 'product';
export const TYPE_STORY = 'story';
export const TYPE_CATBRAND = 'category and brand';
export const TYPE_OUTFIT = 'outfit';
export const TYPE_LINK = 'link';
export const TYPE_INTERNAL_LINK = 'internal';
export const TYPE_CAT = 'category';

class TileTargetMenu extends React.PureComponent<OwnProps, StateProps> {
  public constructor(props: OwnProps) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  public static defaultProps: Partial<OwnProps> = {
    label: 'Choose a target (optional)',
    filter: false,
  };

  private closeMenu = () => {
    this.setState({ isOpen: false });
  };

  private openMenu = (event: any) => {
    this.setState({ isOpen: true, anchorEl: event.currentTarget });
  };

  private onNoTargetClicked = () => {
    this.dispatchValue(TYPE_NO_TARGET);
  }

  private onOutfitClicked = () => {
    this.dispatchValue(TYPE_OUTFIT);
  };

  private onBrandClicked = () => {
    this.dispatchValue(TYPE_BRAND);
  };

  private onStoryClicked = () => {
    this.dispatchValue(TYPE_STORY);
  };

  private onProductClicked = () => {
    this.dispatchValue(TYPE_PRODUCT);
  };

  private onCatBrandClicked = () => {
    this.dispatchValue(TYPE_CATBRAND);
  };

  private onCatClicked = () => {
    this.dispatchValue(TYPE_CAT);
  };

  private onExternalLinkClicked = () => {
    this.dispatchValue(TYPE_LINK);
  };

  private onInternalLinkClicked = () => {
    this.dispatchValue(TYPE_INTERNAL_LINK);
  };

  private dispatchValue(val: string | null): void {
    const { onSelected } = this.props;
    this.closeMenu();
    onSelected(val);
  }

  public render() {
    const { isOpen, anchorEl } = this.state;
    let menuItems = [
      { id: 1, click: this.onNoTargetClicked, label: 'No Target' },
      { id: 2, click: this.onOutfitClicked, label: 'Outfit' },
      { id: 3, click: this.onBrandClicked, label: 'Brand page' },
      { id: 4, click: this.onProductClicked, label: 'Product' },
      { id: 5, click: this.onStoryClicked, label: 'Story' },
      { id: 6, click: this.onCatBrandClicked, label: 'Category and Brand' },
      { id: 7, click: this.onExternalLinkClicked, label: 'External Link' },
      { id: 8, click: this.onInternalLinkClicked, label: 'Internal Link' },
    ];

    if (this.props.filter) {
      const invalidItems = [1, 4, 6, 7, 8];
      menuItems = menuItems.filter(
        menuItem => !invalidItems.includes(menuItem.id)
      );
      menuItems.push({ id: 9, click: this.onCatClicked, label: 'Category' });
    }

    return (
      <div>
        <Button aria-haspopup="true" onClick={this.openMenu}>
          {this.props.label}
        </Button>
        <Menu anchorEl={anchorEl} open={isOpen} onClose={this.closeMenu} PaperProps={{
          style: {
            maxHeight: 300
          }
        }}>
          {menuItems.map((menuItem, index) => (
            <MenuItem key={index} onClick={menuItem.click}>
              {menuItem.label}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

export default TileTargetMenu;



// WEBPACK FOOTER //
// ./src/modules/StoryEdit/components/Stream/TileTargetMenu/index.tsx